// Accept Invitation Sign Up
export const ACCEPT_INVITATION_SIGN_UP_REQUEST = 'ACCEPT_INVITATION_SIGN_UP_REQUEST';
export const ACCEPT_INVITATION_SIGN_UP_DONE = 'ACCEPT_INVITATION_SIGN_UP_DONE';
export const ACCEPT_INVITATION_SIGN_UP_FAILED = 'ACCEPT_INVITATION_SIGN_UP_FAILED';